import '../components/test.css'
import Navbar from "../components/Navbar/stunavbar"
import '../components/Navbar/navbar.css'
import Studentmark from '../components/student/Marksheet'

function StuMark() {
 
  return (
    <div className='newAdmin'>   
   <Navbar/>
   <Studentmark/>
    </div>
  )
}

export default StuMark
